import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { mediaQuery } from '~/src/styles/mixins';
import { MAX_1279, MAX_767 } from '~/src/styles/tokens/break-points';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { COLORS } from '~/src/styles/tokens/colors';

export const OtherDirectionProductsContainer = styled.div`
    position: relative;
    width: 100%;
    height: fit-content;
    flex-direction: column;
    flex-wrap: nowrap;
    margin: 0 auto;
    max-width: ${rem(1552)};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            height: fit-content;
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            height: auto;
        `,
    )};
`;

export const ProductGroupNameContainer = styled.p`
    ${FONTS.text.regular.size17};
    color: ${COLORS.textLightPrimary};
    text-align: center;
    margin-bottom: ${rem(16)};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            height: fit-content;
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            height: auto;
        `,
    )};
`;

export const ProductGroupName = styled.span`
    ${FONTS.text.medium.size17};
`;

export const ProductList = styled.div`
    display: flex;
    justify-content: center;
    gap: ${rem(20)};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            gap: ${rem(16)};
            flex-direction: column;
            align-items: center;
        `,
    )};
`;

export const Product = styled.span`
    color: ${COLORS.textLightPrimaryLink};
    cursor: pointer;
    
    &:hover {
        text-decoration: underline;
        text-underline-position: under;
    }
`;